<template>
  <div class="modal fade" id="country-selector" tabindex="-1" aria-labelledby="countrySelectorLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content country-select-modal">
        <div class="modal-header">
          <h6 class="modal-title" id="countrySelectorLabel">{{ $t('modal.choose_country') }}</h6>
          <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <ul class="row p-3">
            <li class="col-lg-6 mb-2" v-for="country in countries" :key="country.code">
              <a
                  href="#"
                  class="btn btn-country btn-lg btn-block w-100 d-flex align-items-center"
                  :class="{ 'active': $i18n.locale === country.locale }"
                  @click.prevent="setLocale(country.locale)"
                  data-bs-dismiss="modal"
              >
                                <span class="country-selector me-3">
                                    <img
                                        :src="country.flagUrl"
                                        :alt="country.name"
                                        class="language flag-icon"
                                    >
                                </span>
                {{ $t(`countries.${country.code}`) }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CountrySelectorModal",
    data() {
      return {
        countries: [
          { code: 'USA', name: 'USA', locale: 'en', flagUrl: '/images/flags-img/us_flag.jpg' },
          { code: 'Italy', name: 'Italy', locale: 'it', flagUrl: '/images/flags-img/italy_flag.jpg' },
          { code: 'Spain', name: 'Spain', locale: 'es', flagUrl: '/images/flags-img/spain_flag.jpg' },
          { code: 'India', name: 'India', locale: 'en', flagUrl: '/images/flags-img/india_flag.jpg' },
          { code: 'French', name: 'French', locale: 'fr', flagUrl: '/images/flags-img/french_flag.jpg' },
          { code: 'Russia', name: 'Russia', locale: 'ru', flagUrl: '/images/flags-img/russia_flag.jpg' },
          { code: 'Germany', name: 'Germany', locale: 'de', flagUrl: '/images/flags-img/germany_flag.jpg' },
          { code: 'Argentina', name: 'Argentina', locale: 'es', flagUrl: '/images/flags-img/argentina.jpg' },
          { code: 'Malaysia', name: 'Malaysia', locale: 'en', flagUrl: '/images/flags-img/malaysia.jpg' },
          { code: 'Turkey', name: 'Turkey', locale: 'tr', flagUrl: '/images/flags-img/turkey.jpg' },
        ]
      };
    },
    methods: {
      setLocale(locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('user-locale', locale); // Persistance du choix
      }
    }
  };
</script>

<style scoped>
/* Ajoutez ici les styles pour .flag-icon et .btn-country.active */
.flag-icon {
  width: 25px;
  height: auto;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-country.active {
  background-color: #3C50E0 !important;
  color: white !important;
  border-color: #3C50E0 !important;
}
</style>